module.exports = __webpack_public_path__ + "media/fonts/SFProText-Medium-86269e5c921a1c6d5d503c5d2afa5ee7.woff2";